import {
  TemplateFieldFields_TextPermitField,
  TemplateFieldFields_BooleanPermitField,
  TemplateFieldFields_NumberPermitField,
  TemplateFieldFields_DatePermitField,
} from "../operations/fragments/__generated__/TemplateFieldFields";

export const TemplateFieldType = {
  Text: "Text",
  Boolean: "Boolean",
  Number: "Number",
  Date: "Date",
} as const;

export interface TextTemplateField extends TemplateFieldFields_TextPermitField {}

export interface BooleanTemplateField extends TemplateFieldFields_BooleanPermitField {}

export interface NumberTemplateField extends TemplateFieldFields_NumberPermitField {}

export interface DateTemplateField extends TemplateFieldFields_DatePermitField {}

export type TemplateField = TextTemplateField | BooleanTemplateField | NumberTemplateField | DateTemplateField;
